import { FileSignature } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface FormIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const FormIcon: React.FC<FormIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <FileSignature size={size} color={color} />
        </IconWrapper>
    );
};
